import { render, staticRenderFns } from "./ModalAlerts.vue?vue&type=template&id=3e08e1c8"
import script from "./ModalAlerts.vue?vue&type=script&lang=js"
export * from "./ModalAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports